import React, { PropTypes } from 'react'
import { Field } from 'react-redux-form/immutable'

const InputCheckbox = ({ model, label, options, required }) => (
  <Field model={model}>
    <label htmlFor={label}>{label} {required && <span className="req">*</span>}</label>
    <input type="checkbox" />
  </Field>
)

InputCheckbox.propTypes = {
  model: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.array,
  required: PropTypes.bool,
}

export default InputCheckbox



// WEBPACK FOOTER //
// ./src/components/InputCheckbox/index.js